import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import InputUnstyled from '@mui/base/InputUnstyled'
import { Header } from "../../common/Header";
import { getArticles } from "../../utils/data/data";
import { getFastLinks } from "../../utils/data/data";
import { Footer } from "../../common/Footer";
import { Icons } from '../../utils/Icons'
import searchIcon from '../../assets/img/search.svg'
import thunderIcon from '../../assets/img/thunder.svg'

export default function Home() {
  let articles = getArticles();
  let fastLinks = getFastLinks();
  let [searchParams, setSearchParams] = useSearchParams();
  const [first, setfirst] = useState(false);

  return (
    <div className="appContainer">
      <div className="mainHeader">
        <Header />
        <div className="searchWrap">
          <InputUnstyled
            value={searchParams.get("filter") || ""}
            placeholder="¿Cómo podemos ayudarte?"
            className="searchBar"
            startAdornment={<Icons path={searchIcon} className="searchIcon" />}
            onChange={(event) => {
              let filter = event.target.value;
              if (filter) {
                setSearchParams({ filter });
                setfirst(true)
              } else {
                setSearchParams({});
                setfirst(false)
              }
            }}
          />
          {first &&
            <div className="searchResults">
              {articles.filter((articles) => {
                let filter = searchParams.get("filter");
                if (!filter) return true;
                let name = articles.title.toLowerCase();
                return name.includes(filter.toLowerCase());
              }).map((articles) => (
                <Link
                  className='buttonLink'
                  to={`/article/${articles.url}`}
                  key={articles.articleId}
                >
                  {articles.title}
                </Link>
              ))}
              <i>Sin resultados</i>
            </div>
          }
        </div>
      </div>

      <div className="mainWidth">
        {/* Listado de accesos rápidos */}
        <section className="fastList rowXxl">
          <header className="sectionHeader">
            <Icons path={thunderIcon} />
            <h2>Accesos rápidos</h2>
          </header>
          <ul className="buttonLinkList">
            {fastLinks.map((fastLinks) => (
              <li key={fastLinks.linkId}>
                {fastLinks.external === true ?
                  <a
                    className="containedButtonLink"
                    href={fastLinks.url}
                    target={fastLinks.target}
                  >
                    {fastLinks.title}
                  </a>
                  : <Link
                    className="containedButtonLink"
                    to={fastLinks.url}
                  >
                    {fastLinks.title}
                  </Link>
                }
              </li>
            ))}
          </ul>
        </section>

        {/* Listado de contenidos */}
        <div className="homeListsWrap">
          {/* Comenzar */}
          <section className="homeListsArticles">
            <header className="sectionHeader">
              <h2>Comenzar</h2>
            </header>
            <div>
              <ul>
                {articles
                  .sort((a, b) => a.articleId - b.articleId)
                  .filter((article) => {
                    let name = article.category.slug.toLowerCase();
                    return name.startsWith("comenzar");
                  }).map((articles) => (
                    <li key={articles.articleId}>
                      <Link
                        className='buttonLink'
                        to={`/article/${articles.url}`}
                      >
                        {articles.title}
                      </Link>
                    </li>
                  ))}
                  <li>
                    <a
                      className='buttonLink'
                      href="https://concursos.mega.cl/home/"
                      target={"_blank"}
                    >
                      Bases concursos
                    </a>
                  </li>
              </ul>
            </div>
          </section>
          {/* Administrar mi cuenta */}
          <section className="homeListsArticles">
            <header className="sectionHeader">
              <h2>Administrar mi cuenta</h2>
            </header>
            <div>
              <ul>
                {articles.filter((article) => {
                  let name = article.category.slug.toLowerCase();
                  return name.startsWith("cuenta");
                }).map((articles) => (
                  <li key={articles.articleId}>
                    <Link
                      className='buttonLink'
                      to={`/article/${articles.url}`}
                    >
                      {articles.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </section>
          {/* Facturación */}
          <section className="homeListsArticles">
            <header className="sectionHeader">
              <h2>Facturación</h2>
            </header>
            <div>
              <ul>
                {articles.filter((article) => {
                  let name = article.category.slug.toLowerCase();
                  return name.startsWith("facturacion");
                }).map((articles) => (
                  <li key={articles.articleId}>
                    <Link
                      className='buttonLink'
                      to={`/article/${articles.url}`}
                    >
                      {articles.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </section>
        </div>
      </div>
      <Footer />
    </div>
  );
}